import { Button, Modal } from "@mui/material";
import InputField from "components/Input/InputField";
import { AiOutlineDelete } from "react-icons/ai";

const FeesBreakdownModal = ({ open, onClose, selectedCourse, setSelectedCourse, onSave }) => {
  const addNewFeesBreakdown = () => {
    setSelectedCourse((prev) => ({
      ...prev,
      feesBreakdown: [
        ...(prev.feesBreakdown || []),
        {
          uuid: crypto.randomUUID(),
          maximum: "",
          average: "",
          minimum: "",
        },
      ],
    }));
  };

  const removeFeesBreakdown = (index) => {
    setSelectedCourse((prev) => ({
      ...prev,
      feesBreakdown: prev.feesBreakdown.filter((_, i) => i !== index),
    }));
  };

  const handleFeesBreakdownChange = (index, field, value) => {
    setSelectedCourse((prev) => ({
      ...prev,
      feesBreakdown: prev?.feesBreakdown?.map((fee, i) =>
        i === index ? { ...fee, [field]: value } : fee
      ),
    }));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-app-surface p-6 rounded-lg shadow-xl w-[600px]">
        <h3 className="text-lg font-semibold mb-4">Total Fees Breakdown</h3>

        <table className="w-full border">
          <thead>
            <tr>
              <th className="px-4 py-2 border">S.N.</th>
              <th className="px-4 py-2 border">Maximum</th>
              <th className="px-4 py-2 border">Average</th>
              <th className="px-4 py-2 border">Minimum</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {selectedCourse?.feesBreakdown?.map((fee, idx) => (
              <tr key={idx}>
                <td className="px-4 py-2 border">{idx + 1}</td>

                <td className="px-4 py-2 border">
                  <InputField
                    type="number"
                    value={fee.maximum}
                    onChange={(e) => handleFeesBreakdownChange(idx, "maximum", e.target.value)}
                  />
                </td>
                <td className="px-4 py-2 border">
                  <InputField
                    type="number"
                    value={fee.average}
                    onChange={(e) => handleFeesBreakdownChange(idx, "average", e.target.value)}
                  />
                </td>
                <td className="px-4 py-2 border">
                  <InputField
                    type="number"
                    value={fee.minimum}
                    onChange={(e) => handleFeesBreakdownChange(idx, "minimum", e.target.value)}
                  />
                </td>
                <td className="px-4 py-2 border">
                  <button
                    type="button"
                    onClick={() => removeFeesBreakdown(idx)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <AiOutlineDelete />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Button variant="outlined" onClick={addNewFeesBreakdown} className="mt-4">
          Add Row
        </Button>

        <div className="flex justify-end gap-4 mt-6">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onSave}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FeesBreakdownModal;
